export default __webpack_public_path__ + "static/media/logo192.f7ee4882.png";